var _defs, _polygon, _polygon2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovapointSlopeSurfaceSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointSlopeSurface_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28 10.3 28 12.51 28 28 4 28 4 23.7 4 21.49 28 10.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.27 11.07 10.43 9.26 9.01 13.23 13.02 14.82 12.12 12.88 22.99 7.81 22.15 6 11.27 11.07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointSlopeSurfaceSvg);
export default __webpack_public_path__ + "static/media/NovapointSlopeSurface_svg.b174f77553272b998988db0e3f0e34a3.svg";
export { ForwardRef as ReactComponent };